import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface TestimonialRequest {
  name: string;
  role?: string;
  rating: number;
  message: string;
  captchaToken: string;
}

export interface TestimonialResponse {
  id: string;
  name: string;
  role?: string;
  rating: number;
  message: string;
  createdAt: string;
}

@Injectable({ providedIn: 'root' })
export class TestimonialsService {
  private readonly http = inject(HttpClient);

  submit(request: TestimonialRequest): Observable<TestimonialResponse> {
    return this.http.post<TestimonialResponse>('/api/testimonials', request);
  }

  list(): Observable<TestimonialResponse[]> {
    return this.http.get<TestimonialResponse[]>('/api/testimonials');
  }
}
